const Endpoints = {
  LOGIN_OTP: "/Loginotp",
  VERIFY_LOGIN: "/verify-login-otp",
  USER_LOGIN: "/dashboard-login",
  FETCH_DASHBOARDS: "/fetch-dashboard-links",
  CHECK_CHANGE_PASSWORD: "/can-change-password",
  CHANGE_PASSWORD: "/change-dashboard-password",

};

export default Endpoints;
